import { Color } from './types';

const grey: Color = {
    50: '#E4EDF4',
    100: '#8ea8c3',
    200: '#8E98A2',
    300: '#0e1823'
};

export default grey;
